<template>
	<div id="materials-journal">
		<loader v-if="loading" />

		<v-container v-else-if="journalCards.length" fluid class="pa-4">
			<v-row dense>
				<v-col
					v-for="(card, index) in journalCards"
					:key="card.id || index"
					cols="12"
					sm="6"
					lg="4"
				>
					<v-card outlined color="grey lighten-4" class="elevation-0">
						<v-card-text class="pa-4">
							<h4 class="d-block text-subtitle-1 font-weight-bold primary--text mb-3">
								{{ card.materialName }}
							</h4>

							<v-row dense>
								<v-col cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.customer-name') }}:</span>
									<span>{{ card.customerName }}</span>
								</v-col>

								<v-col cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.customer-type') }}:</span>
									<span>{{ card.customerType }}</span>
								</v-col>

								<v-col cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.date') }}:</span>
									<span>{{ card.date }}</span>
								</v-col>

							<template >
								<v-col v-if="usePrices" cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.price') }}:</span>
									<span>{{ card.price }}</span>
								</v-col>

								<v-col cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.quantity') }}:</span>
									<span>{{ card.quantity }}</span>
								</v-col>

								<!-- <v-col cols="12" sm="6" class="d-flex align-center py-1">
									<span class="font-weight-bold me-2">{{ $T('MaterialsJournal.payment-method') }}:</span>
									<span>{{ card.paymentMethod }}</span>
								</v-col> -->
							</template>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else fluid class="materials-journal-empty pa-4">
			<div class="d-flex flex-column justify-center align-center text-center">
				<v-icon x-large class="mb-3">mdi-database-off-outline</v-icon>
				<span class="secondary--text text--darken-2">{{ $T('MaterialsJournal.no-data-to-show') }}</span>
			</div>
		</v-container>
	</div>
</template>

<script>
import Loader from '@/components/Loader'
import { mapGetters, mapState } from 'vuex'
import { usePrices } from '@/configs/general.configs'
import moment from 'moment'

export default {
	name: 'MaterialsJournal',

	components: {
		Loader,
	},

	data() {
		return {
			loading: true,
			usePrices,
		}
	},

	computed: {
		...mapState({
			journalTransactions: state => state.materialsTransactions.transactionsJournal,
			materials: state => state.materials.materials,
			entities: state => state.entities.entities,
			customersTypes: state => state.entities.customersTypes,
		}),

		...mapGetters({
			getMaterialById: 'materials/getMaterialById',
			getEntityByAccountId: 'entities/getEntityByAccountId',
			getCustomerTypeById: 'entities/getCustomerTypeById',
		}),

		journalCards() {
			return (this.journalTransactions || []).map(this.mapTransactionToCard)
		}
	},

	methods: {
		moment,

		mapTransactionToCard(transaction) {
			return {
				id: transaction.id || transaction.transactionId || `${transaction.accountId}-${transaction.materialId}-${transaction.date}`,
				materialName: this.resolveMaterialName(transaction),
				customerName: this.getEntityByAccountId(transaction.accountId)?.name || '-',
				customerType: this.getCustomerTypeById(this.getEntityByAccountId(transaction.accountId)?.entityTypeId)?.name || '-',
				date: this.formatDate(transaction.date),
				price: this.formatValue(transaction.price),
				quantity: this.formatValue(transaction.amount),
			}
		},

		resolveMaterialName(transaction) {
			const material = this.getMaterialById(transaction.materialId)
			return material?.name || this.$T('MaterialsJournal.unknown')
		},

		formatDate(value) {
			if (!value) return this.$T('MaterialsJournal.unknown')
			if (!window.moment) return value
			return window.moment(value).format('YYYY-MM-DD')
		},

		formatValue(value) {
			if (value === null || value === undefined || value === '') {
				return this.$T('MaterialsJournal.unknown')
			}

			return this.$options.filters?.formatNumber
				? this.$options.filters.formatNumber(value, 3)
				: value
		},
	},

	mounted() {
		this.loading = true

		Promise.all([
			!this.materials.length ? this.$store.dispatch('materials/fetchAll', { name: null, materialFormId: null }) : null,
			!this.entities.length ? this.$store.dispatch('entities/fetchAllData', { typeId: null, name: null, perPage: 1000 }) : null,
			!this.customersTypes.length ? this.$store.dispatch('entities/fetchEntityType') : null,
			
			this.$store.dispatch('materialsTransactions/fetchJournal', { 
				fromDate: moment().format('YYYY-MM-DD'), 
				toDate: moment().format('YYYY-MM-DD') 
			}),
		]).finally(() => {
			this.loading = false
		})
	},

	beforeDestroy() {
		this.$store.dispatch('materialsTransactions/resetJournal')
	}
}
</script>

<style scoped>
.materials-journal-empty {
	min-height: calc(100vh - 130px);
}
</style>
